export const INVALID_DATE_MESSAGE = 'Date and time MUST be in the future';
export const QUEUED_BLAST_GUARD_MODAL_TEXT = `
  Looks like you already have a Chat Blast in progress. This can take a few minutes
  to send to all of the contacts in your chosen audience. Check back here soon for updated statistics!
`;

export const QUEUED_BLAST_GUARD_MODAL_HEADER_TEXT = 'Hold on a second!';
